import Sorting from './Sorting';
import Chevron from './Chevron';
import DoubleChevron from './DoubleChevron';
import { ReactComponent as BinSvg } from '../assets/icons/bin.svg';
import { ReactComponent as ClinicalTrialsSvg } from '../assets/icons/clinical-trials.svg';
import { ReactComponent as CloudUploadSvg } from '../assets/icons/cloud-upload.svg';
import { ReactComponent as DashboardSvg } from '../assets/icons/dashboard.svg';
import { ReactComponent as EditSmallSvg } from '../assets/icons/edit-small.svg';
import { ReactComponent as EditSvg } from '../assets/icons/edit.svg';
import { ReactComponent as FileSvg } from '../assets/icons/file.svg';
import { ReactComponent as LogoutSvg } from '../assets/icons/logout.svg';
import { ReactComponent as PlusSvg } from '../assets/icons/plus.svg';
import { ReactComponent as MinusSvg } from '../assets/icons/minus.svg';
import { ReactComponent as QueriesSvg } from '../assets/icons/queries.svg';
import { ReactComponent as SettingsSvg } from '../assets/icons/settings.svg';
import { ReactComponent as SubjectsSvg } from '../assets/icons/subjects.svg';
import { ReactComponent as UploadSvg } from '../assets/icons/upload.svg';
import { ReactComponent as DetachSvg } from '../assets/icons/detach.svg';
import { ReactComponent as ReattachSvg } from '../assets/icons/reattach.svg';
import { ReactComponent as CloseSvg } from '../assets/icons/close.svg';
import { ReactComponent as BigLogoSvg } from '../assets/logo.svg';
import { ReactComponent as SmallLogoSvg } from '../assets/logo-small.svg';
import { ReactComponent as VerticalLogoSvg } from '../assets/logo-vertical.svg';
import { ReactComponent as IAGLogoSvg } from '../assets/iag-logo.svg';
import { ReactComponent as NoContentSvg } from '../assets/icons/no-content.svg';
import { ReactComponent as LibrarySvg } from '../assets/icons/library.svg';
import { ReactComponent as InventorySvg } from '../assets/icons/inventory.svg';
import { ReactComponent as UsersSvg } from '../assets/icons/users.svg';
import { ReactComponent as DotsSvg } from '../assets/icons/dots.svg';
import { ReactComponent as ListSvg } from '../assets/icons/list.svg';
import { ReactComponent as QuestionSignSvg } from '../assets/icons/question-sign.svg';
import { ReactComponent as CalendarClearSvg } from '../assets/icons/calendar-clear.svg';
import { ReactComponent as SiteSvg } from '../assets/icons/site.svg';
import { ReactComponent as SitesSvg } from '../assets/icons/sites.svg';
import { ReactComponent as IAGLogoColourfullSvg } from '../assets/iag_logo_colourful.svg';
import { ReactComponent as SearchSvg } from '../assets/icons/search.svg';
import { ReactComponent as TrashSvg } from '../assets/icons/trash.svg';
import { ReactComponent as ImagingSvg } from '../assets/icons/imaging.svg';
import { ReactComponent as NoDataSvg } from '../assets/icons/noData.svg';
import { ReactComponent as SelectArrowSvg } from '../assets/icons/select-arrow.svg';
import { ReactComponent as CohortsSvg } from '../assets/icons/cohorts.svg';
import { ReactComponent as AttentionSvg } from '../assets/icons/attention.svg';
import { ReactComponent as ArchiveSvg } from '../assets/icons/archive.svg';
import { ReactComponent as AlertIconSvg } from '../assets/icons/alert-icon.svg';
import { ReactComponent as CheckMarkSvg } from '../assets/icons/checkmark.svg';
import { ReactComponent as StatusWarningSvg } from '../assets/icons/status-warning.svg';
import { ReactComponent as VisitSvg } from '../assets/icons/visit.svg';
import { ReactComponent as EdtfSvg } from '../assets/icons/edtf.svg';
import { ReactComponent as DataValidationSvg } from '../assets/icons/dataValidation.svg';
import { ReactComponent as ArrowSvg } from '../assets/icons/arrow.svg';
import { ReactComponent as ArrowUpSvg } from '../assets/icons/arrow_up.svg';
import { ReactComponent as ArrowDownSvg } from '../assets/icons/arrow_down.svg';
import { ReactComponent as FileSelectSvg } from '../assets/icons/selectFile.svg';
import { ReactComponent as WarningSvg } from '../assets/icons/waring.svg';
import { ReactComponent as FilterSvg } from '../assets/icons/filter.svg';
import { ReactComponent as ZipFileSvg } from '../assets/icons/zip-file.svg';
import { ReactComponent as FileDicomSvg } from '../assets/icons/file-dicom.svg';
import { ReactComponent as FileDxaSvg } from '../assets/icons/file-dxa.svg';
import { ReactComponent as SpinnerThinSvg } from '../assets/icons/spinner-thin.svg';
import { ReactComponent as DinoInactiveSvg } from '../assets/icons/dino-inactive.svg';
import { ReactComponent as DinoActiveSvg } from '../assets/icons/dino-active.svg';
import { ReactComponent as UnionCircleSvg } from '../assets/icons/union-circle.svg';
import { ReactComponent as CheckSvg } from '../assets/icons/check.svg';
import { ReactComponent as LockOpenSvg } from '../assets/icons/lock-open.svg';
import { ReactComponent as LockCloseSvg } from '../assets/icons/lock-close.svg';
import { ReactComponent as BaselineSvg } from '../assets/icons/baseline.svg';
import { ReactComponent as SendSvg } from '../assets/icons/send.svg';
import { ReactComponent as QcSvg } from '../assets/icons/qc.svg';
import { ReactComponent as Team } from '../assets/icons/team.svg';
import { ReactComponent as Suspend } from '../assets/icons/suspend.svg';
import { ReactComponent as VectorSVG } from '../assets/icons/vector.svg';
import { ReactComponent as VectorSuccessSvg } from '../assets/icons/vector-success.svg';
import { ReactComponent as CardsSvg } from '../assets/cards.svg';
import { ReactComponent as NoConnectionSvg } from '../assets/icons/no-connection.svg';
import { ReactComponent as ReassignSvg } from '../assets/icons/reassign.svg';
import { ReactComponent as MailSvg } from '../assets/icons/mail.svg';
import { ReactComponent as SwitchSpaceSvg } from '../assets/icons/switch-space.svg';
import { ReactComponent as RhombusSvg } from '../assets/icons/rhombus.svg';
import { ReactComponent as HexagonSvg } from '../assets/icons/hexagon.svg';
import { ReactComponent as TriangleSvg } from '../assets/icons/triangle.svg';
import { ReactComponent as CircleSvg } from '../assets/icons/circle.svg';
import { ReactComponent as SquareSvg } from '../assets/icons/square.svg';
import { ReactComponent as DoubleCircleSvg } from '../assets/icons/double-circle.svg';
import { ReactComponent as HexagonStarSvg } from '../assets/icons/hexagon-star.svg';
import { ReactComponent as PentagonSvg } from '../assets/icons/pentagon.svg';
import { ReactComponent as CheckCircleSvg } from '../assets/icons/check-circle.svg';
import { ReactComponent as MessageSvg } from '../assets/icons/message.svg';
import { ReactComponent as AuditSvg } from '../assets/icons/audit.svg';
import { ReactComponent as ExportSvg } from '../assets/icons/export.svg';
import { ReactComponent as FilledCalendarSvg } from '../assets/icons/calendar-filled.svg';
import { ReactComponent as FilterDetailedSvg } from '../assets/icons/filter-detailed.svg';
import { ReactComponent as RefreshSvg } from '../assets/icons/refresh.svg';
import { ReactComponent as EyeIconSvg } from '../assets/icons/eye-icon.svg';
import { ReactComponent as EyeCloseSvg } from '../assets/icons/eye-close-icon.svg';
import { ReactComponent as CrossSvg } from '../assets/icons/cross.svg';
import { ReactComponent as FilePdf } from '../assets/icons/file-pdf.svg';
import { ReactComponent as FileCheck } from '../assets/icons/file-check.svg';
import { ReactComponent as FileAndEmail } from '../assets/icons/file-and-email.svg';
import { ReactComponent as HexagonArrow } from '../assets/icons/hexagon-arrow.svg';
import { ReactComponent as BackCurvedArrow } from '../assets/icons/back-curved-arrow.svg';
import { ReactComponent as Process } from '../assets/icons/process-icon.svg';
import { ReactComponent as ArrowProcess } from '../assets/icons/arrow-process-icon.svg';
import { ReactComponent as RecentReports } from '../assets/icons/recentReports.svg';
import { ReactComponent as CheckWithEllipse } from '../assets/icons/check-with-ellipse.svg';
import { ReactComponent as StatusCorrect } from '../assets/icons/status-correct.svg';
import { ReactComponent as StatusIncorrect } from '../assets/icons/status-incorrect.svg';
import { ReactComponent as Line } from '../assets/icons/line.svg';
import { ReactComponent as TwoWayArrows } from '../assets/icons/two-way-arrows.svg';
import { ReactComponent as ArrowRightSquare } from '../assets/icons/arrow-right-square.svg';
import { ReactComponent as LoopSquare } from '../assets/icons/loop-square.svg';
import { ReactComponent as Tag } from '../assets/icons/tag.svg';
import { ReactComponent as Dependency } from '../assets/icons/dependency.svg';
import { ReactComponent as Copy } from '../assets/icons/copy.svg';
import { ReactComponent as Reopen } from '../assets/icons/reopen.svg';
import { ReactComponent as CloseCircle } from '../assets/icons/close-circle.svg';
import { ReactComponent as ScoringForm } from '../assets/icons/scoring-form.svg';
import { ReactComponent as Run } from '../assets/icons/run.svg';
import { ReactComponent as Download } from '../assets/icons/download.svg';
import { ReactComponent as ProcessWithEllipse } from '../assets/icons/process-with-ellipse.svg';
import { ReactComponent as SingleDot } from '../assets/icons/single-dot.svg';
import { ReactComponent as Puzzle } from '../assets/icons/puzzle.svg';
import { ReactComponent as Attach } from '../assets/icons/attach.svg';
import { ReactComponent as CloseNew } from '../assets/icons/close-new.svg';
import { ReactComponent as ProcessNew } from '../assets/icons/process-new.svg';
import { ReactComponent as CalendarClearOutline } from '../assets/icons/calendar-clear-outline.svg';
import { ReactComponent as Resolve } from '../assets/icons/resolve.svg';
import { ReactComponent as ChatBubble } from '../assets/icons/chatbubble-outline.svg';
import { ReactComponent as AddNote } from '../assets/icons/add-note.svg';
import { ReactComponent as Reply } from '../assets/icons/reply.svg';
import { ReactComponent as Result } from '../assets/icons/result.svg';

export const CloseIcon = CloseSvg;
export const StatusWarningIcon = StatusWarningSvg;
export const AlertIcon = AlertIconSvg;
export const CheckMarkIcon = CheckMarkSvg;
export const UploadIcon = UploadSvg;
export const SubjectsIcon = SubjectsSvg;
export const SettingsIcon = SettingsSvg;
export const QueriesIcon = QueriesSvg;
export const PlusIcon = PlusSvg;
export const MinusIcon = MinusSvg;
export const LogoutIcon = LogoutSvg;
export const FileIcon = FileSvg;
export const FileDicomIcon = FileDicomSvg;
export const FileDxaIcon = FileDxaSvg;
export const EditIcon = EditSvg;
export const RefreshIcon = RefreshSvg;
export const EditSmallIcon = EditSmallSvg;
export const DashboardIcon = DashboardSvg;
export const UploadBoxIcon = CloudUploadSvg;
export const ClinicalTrialsIcon = ClinicalTrialsSvg;
export const BinIcon = BinSvg;
export const NoContentIcon = NoContentSvg;
export const LibraryIcon = LibrarySvg;
export const InventoryIcon = InventorySvg;
export const UsersIcon = UsersSvg;
export const QuestionSignIcon = QuestionSignSvg;
export const DotsIcon = DotsSvg;
export const CalendarClearIcon = CalendarClearSvg;
export const SiteIcon = SiteSvg;
export const SitesIcon = SitesSvg;
export const SearchIcon = SearchSvg;
export const TrashIcon = TrashSvg;
export const BigLogo = BigLogoSvg;
export const SmallLogo = SmallLogoSvg;
export const VerticalLogo = VerticalLogoSvg;
export const IAGLogo = IAGLogoSvg;
export const IAGLogoColourfull = IAGLogoColourfullSvg;
export const Imaging = ImagingSvg;
export const NoData = NoDataSvg;
export const SelectArrow = SelectArrowSvg;
export const Cohorts = CohortsSvg;
export const Attention = AttentionSvg;
export const ArchiveIcon = ArchiveSvg;
export const Visit = VisitSvg;
export const Edtf = EdtfSvg;
export const DataValidation = DataValidationSvg;
export const Arrow = ArrowSvg;
export const ArrowUpIcon = ArrowUpSvg;
export const ArrowDownIcon = ArrowDownSvg;
export const FileSelect = FileSelectSvg;
export const Warning = WarningSvg;
export const ListIcon = ListSvg;
export const Filter = FilterSvg;
export const ZipFile = ZipFileSvg;
export const SpinnerThin = SpinnerThinSvg;
export const DinoInactive = DinoInactiveSvg;
export const DinoActive = DinoActiveSvg;
export const UnionCircle = UnionCircleSvg;
export const Baseline = BaselineSvg;
export const CheckIcon = CheckSvg;
export const CheckStrokeIcon = CheckMarkSvg;
export const LockOpenIcon = LockOpenSvg;
export const LockCloseIcon = LockCloseSvg;
export const SendIcon = SendSvg;
export const QcIcon = QcSvg;
export const TeamIcon = Team;
export const SuspendIcon = Suspend;
export const MessageIcon = MessageSvg;
export const DetachIcon = DetachSvg;
export const ReattachIcon = ReattachSvg;

export const VectorIcon = VectorSVG;
export const VectorSuccessIcon = VectorSuccessSvg;

export const Cards = CardsSvg;
export const NoConnection = NoConnectionSvg;
export const ReassignIcon = ReassignSvg;
export const MailIcon = MailSvg;
export const SwitchSpaceIcon = SwitchSpaceSvg;
export const RhombusIcon = RhombusSvg;
export const HexagonIcon = HexagonSvg;
export const TriangleIcon = TriangleSvg;
export const CircleIcon = CircleSvg;
export const SquareIcon = SquareSvg;
export const DoubleCircleIcon = DoubleCircleSvg;
export const HexagonStarIcon = HexagonStarSvg;
export const PentagonIcon = PentagonSvg;

export const CheckCircleIcon = CheckCircleSvg;
export const AuditTrialsIcon = AuditSvg;
export const ExportIcon = ExportSvg;
export const FilledCalendarIcon = FilledCalendarSvg;
export const FilterDetailedIcon = FilterDetailedSvg;
export const EyeIcon = EyeIconSvg;
export const EyeCloseIcon = EyeCloseSvg;
export const CrossIcon = CrossSvg;
export const FilePdfIcon = FilePdf;
export const FileCheckIcon = FileCheck;
export const FileAndEmailIcon = FileAndEmail;
export const HexagonArrowIcon = HexagonArrow;
export const BackCurvedArrowIcon = BackCurvedArrow;
export const ProcessIcon = Process;
export const ArrowProcessIcon = ArrowProcess;
export const RecentReportsIcon = RecentReports;
export const CheckWithEllipseIcon = CheckWithEllipse;
export const StatusCorrectIcon = StatusCorrect;
export const StatusIncorrectIcon = StatusIncorrect;
export const LineIcon = Line;
export const TwoWayArrowsIcon = TwoWayArrows;
export const ArrowRightSquareIcon = ArrowRightSquare;
export const LoopSquareIcon = LoopSquare;
export const TagIcon = Tag;
export const DependencyIcon = Dependency;
export const CopyIcon = Copy;
export const ReopenIcon = Reopen;
export const CloseCircleIcon = CloseCircle;
export const ScoringFormIcon = ScoringForm;
export const RunIcon = Run;
export const DownloadIcon = Download;
export const ProcessWithEllipseIcon = ProcessWithEllipse;
export const SingleDotIcon = SingleDot;
export const PuzzleIcon = Puzzle;
export const AttachIcon = Attach;
export const CloseNewIcon = CloseNew;
export const ProcessNewIcon = ProcessNew;
export const CalendarClearOutlineIcon = CalendarClearOutline;
export const ResolveIcon = Resolve;
export const ChatBubbleIcon = ChatBubble;
export const AddNoteIcon = AddNote;
export const ReplyIcon = Reply;
export const ResultIcon = Result;

export const icons = {
  dashboard: DashboardIcon,
  subjects: SubjectsIcon,
  queries: QueriesIcon,
  plus: PlusIcon,
  minus: MinusIcon,
  settings: SettingsIcon,
  refresh: RefreshIcon,
  logout: LogoutIcon,
  bin: BinIcon,
  edit: EditIcon,
  upload: UploadIcon,
  close: CloseIcon,
  message: MessageIcon,
  sorting: Sorting,
  chevron: Chevron,
  doubleChevron: DoubleChevron,
  uploadBox: UploadBoxIcon,
  file: FileIcon,
  clinicalTrials: ClinicalTrialsIcon,
  noContent: NoContentIcon,
  library: LibraryIcon,
  inventory: InventoryIcon,
  users: UsersIcon,
  questionSign: QuestionSignIcon,
  site: SiteIcon,
  sites: SitesIcon,
  search: SearchIcon,
  trash: TrashSvg,
  imaging: Imaging,
  alert: AlertIcon,
  checkmark: CheckMarkIcon,
  statusWarning: StatusWarningIcon,
  noData: NoData,
  cohorts: Cohorts,
  attention: Attention,
  dots: DotsIcon,
  archive: ArchiveSvg,
  visit: Visit,
  edtf: Edtf,
  dataValidation: DataValidation,
  arrow: Arrow,
  arrowUp: ArrowUpIcon,
  arrowDown: ArrowDownIcon,
  fileSelect: FileSelect,
  warning: Warning,
  detach: DetachIcon,
  reattach: ReattachIcon,
  filter: Filter,
  zipFile: ZipFile,
  list: ListSvg,
  spinnerThin: SpinnerThin,
  dinoInactive: DinoInactive,
  dinoActive: DinoActive,
  unionCircle: UnionCircle,
  check: CheckIcon,
  lockOpen: LockOpenIcon,
  lockClose: LockCloseIcon,
  baseline: Baseline,
  send: SendIcon,
  qc: QcIcon,
  team: TeamIcon,
  suspend: SuspendIcon,
  vector: VectorIcon,
  vectorSuccess: VectorSuccessIcon,
  reassign: ReassignSvg,
  mail: MailIcon,
  switchSpace: SwitchSpaceIcon,
  rhombus: RhombusIcon,
  hexagon: HexagonIcon,
  triangle: TriangleIcon,
  circle: CircleIcon,
  square: SquareIcon,
  doubleCircle: DoubleCircleIcon,
  hexagonStar: HexagonStarIcon,
  pentagon: PentagonIcon,
  auditTrials: AuditTrialsIcon,
  export: ExportIcon,
  filterDetailed: FilterDetailedIcon,
  fileDicom: FileDicomIcon,
  fileDxa: FileDxaIcon,
  cross: CrossIcon,
  filePdf: FilePdfIcon,
  fileCheck: FileCheckIcon,
  fileAndEmail: FileAndEmailIcon,
  process: ProcessIcon,
  arrowProcess: ArrowProcessIcon,
  checkWithEllipse: CheckWithEllipseIcon,
  statusCorrect: StatusCorrectIcon,
  statusIncorrect: StatusIncorrectIcon,
  line: LineIcon,
  twoWayArrows: TwoWayArrowsIcon,
  arrowRightSquare: ArrowRightSquareIcon,
  loopSquare: LoopSquareIcon,
  tag: TagIcon,
  dependency: DependencyIcon,
  copy: CopyIcon,
  reopen: ReopenIcon,
  closeCircle: CloseCircleIcon,
  scoringForm: ScoringFormIcon,
  run: RunIcon,
  download: DownloadIcon,
  processWithEllipse: ProcessWithEllipseIcon,
  singleDot: SingleDotIcon,
  puzzle: PuzzleIcon,
  attach: AttachIcon,
  closeNew: CloseNewIcon,
  processNew: ProcessNewIcon,
  calendarClearOutline: CalendarClearOutlineIcon,
  resolve: ResolveIcon,
  chatBubble: ChatBubbleIcon,
  addNote: AddNoteIcon,
  reply: ReplyIcon,
  result: ResultIcon,
};

export default icons;
